<main [class.mobile]="mobile$ | async">
  <nav>
    <button (click)="toggleSidenav()" [class.open]="opened">
      <i class="fa-solid fa-bars"></i>
    </button>
    
    <div class="page-title" #pageTitleContainer>
      @let title = pageTitle.title();

      <a class="logo" [routerLink]="routeTarget()">
        @if (title && ((mobile$ | async) || (pageTitleContainer.offsetWidth < 530))) {
          <img class="icon" src="assets/images/icon_only.svg" alt="Novus Logo" />
        }
        @else {
          <img class="full" src="assets/images/logo_deltanext_inline.svg" alt="Novus Logo" />
        }
      </a>
      
      @if (title){
        <span class="custom-title" #titleTextContainer>{{title}}</span>
      }
    </div>

    <section class="nav-actions">
      <novus-user-menu></novus-user-menu>
    </section>
  </nav>
  <section>
    @if (isNavigating()) {
      <mat-progress-bar [mode]="'indeterminate'" class="progress-spinner"></mat-progress-bar>
    }
    @if (opened) {
      <div class="sidebar-backdrop" (click)="closeSidebar()"></div>
    }
    <div class="overlay" [class.closed]="!opened" [class]="(mobile$ | async) ? 'mobile' : 'desktop'">
      <div id="particles" #particles></div>
      <section>
        <div class="large-logo">
          <img src="assets/images/logo_deltanext_nice.svg" alt="Novus Logo" />
        </div>
        <novus-nav-menu (clickedItem)="closeSidebar()"></novus-nav-menu>
      </section>
    </div>
    <div class="content">
      <router-outlet />
    </div>
  </section>
</main>